import parse from 'html-react-parser';

type Props = {
    bgcolor: string;
    blurb: string;
    icon: string;
    textcolor: string;
};

const IconTextBlurb = ({
    bgcolor,
    blurb,
    children,
    icon,
    textcolor,
}: React.PropsWithChildren<Props>) => {
    const toHtml = (p: string) => {
        return parse(p);
    };

    return (
        <div
            className={`w-full flex flex-col justify-center md:flex-row md:justify-start p-4 md:p-6 rounded-lg ${bgcolor}`}
        >
            <img src={icon} alt="" className="mb-4 md:mb-0 md:mr-8" width="64" height="64" />
            <div className="flex flex-col justify-left">
                <div className={`text-base mb-2 ${textcolor}`}>{toHtml(blurb)}</div>
                {children}
            </div>
        </div>
    );
};

export default IconTextBlurb;
